<template>
  <div class="list">
    <div class="header">
      <div class="l" />
      <div class="r">
        <el-button
          type="primary"
          @click="()=> dialogVisible = true"
        >
          新建线下课程
        </el-button>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :table-column="tableColumn"
      :pagination="true"
      @changeBypagination="tableHandle"
      @buttonClick="buttonClick"
    />
    <course-offline-dialog
      :dialog-visible.sync="dialogVisible"
      :item="courseOfflineItem"
      @confirm="getList"
      @close="()=> courseOfflineItem = {}"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import courseOfflineDialog from '@/components/common/courseOfflineDialog.vue';

export default {
  name: 'Home',
  components: {
    dataTable,
    courseOfflineDialog,
  },
  data() {
    return {
      dialogVisible: false,
      searchForm: {
        pageNum: 1,
        pageSize: 10,
      },
      tabelData: {},
      courseOfflineItem: {},
      tableColumn: [
        {
          key: 'courseName',
          label: '课程名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'certNo',
          label: '证书编号',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'createTime',
          label: '创建时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'control',
          label: '操作',
          width: '170px',
          dataType: 'component',
          renderProps: [
            {
              text: '编辑', renderKey: null, type: 'primary', eventIndex: 0, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取列表
    async getList() {
      const result = await axClient.cert.offlineCourse(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.courseOfflineItem = item;
          this.dialogVisible = true;
          break;
        default:
          break;
      }
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  .header {
    padding: 16px 0;
    display: flex;
    justify-content: space-between;
    .l {
      display: flex;
      align-items: center;
      .label {
        font-weight: 500;
        font-size: 14px;
        margin-right: 12px;
        min-width: 50px;
      }
      .el-select {
        margin-right: 15px;
        flex: 1;
      }
    }
    .r {
      display: flex;
      align-items: center;
      & > .el-button {
        flex: 1;
        margin-left: 15px;
        min-width: auto;
      }
    }
  }
}
</style>
